import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TableConfig } from 'app/component-library/table/table-config';
import { MaintenanceStrategyDetailsService } from 'app/maintenance-strategies-library/details/maintenance-strategy-details.service';
import { MaintenanceStrategyPlannedMaintenance } from 'app/viewmodels/maintenance-strategies/maintenance-strategy-planned-maintenance';
import { LazyLoadEvent } from 'primeng/api';
import { Table as DataTable } from 'primeng/table';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MaintenanceStrategyPlannedMaintenanceTableConfigService } from '../maintenance-strategy-planned-maintenance-table-config.service';

@Component({
  selector: 'hb-maintenance-strategy-available-planned-maintenance-table',
  templateUrl: './available.component.html',
})
export class MaintenanceStrategyAvailablePlannedMaintenanceTableComponent implements OnInit, OnDestroy {
  @Input() plannedMaintenance: MaintenanceStrategyPlannedMaintenance[] = [];
  @Input() canSelect: boolean = false;

  @Output() selectionChanged = new EventEmitter<MaintenanceStrategyPlannedMaintenance[]>(null);

  @ViewChild('table', { static: false }) table: DataTable;

  public currentAvailableItems: MaintenanceStrategyPlannedMaintenance[] = [];
  public selectedMaintenance: MaintenanceStrategyPlannedMaintenance[] = [];

  public get config(): TableConfig {
    return this.tableConfigService.availableItemsConfig;
  }

  private unsubscribe: Subject<boolean> = new Subject();

  constructor(
    private tableConfigService: MaintenanceStrategyPlannedMaintenanceTableConfigService,
    private detailsService: MaintenanceStrategyDetailsService
  ) { }

  public ngOnInit(): void {
    this.tableConfigService.initAvailableItemsTableConfig();
    this.detailsService.maintenanceStrategy.pipe(takeUntil(this.unsubscribe)).subscribe(this.resetLocalState.bind(this));
    this.detailsService.currentPageRows.pipe(takeUntil(this.unsubscribe)).subscribe(currentPageRows => this.currentAvailableItems = currentPageRows);
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  public loadAvailableMaintenanceLazy(event: LazyLoadEvent): void {
    this.detailsService.loadAvailableMaintenanceLazy(event);
  }

  public selectionChange(event: MaintenanceStrategyPlannedMaintenance[]): void {
    this.setSelectedMaintenance(event);
    if (this.selectionChanged) {
      this.selectionChanged.emit(event);
    }
  }

  private clearSelectedMaintenance(): void {
    this.setSelectedMaintenance([]);
  }

  private setSelectedMaintenance(items: MaintenanceStrategyPlannedMaintenance[]): void {
    this.selectedMaintenance = items;
  }

  private resetLocalState(): void {
    this.clearSelectedMaintenance();
  }
}
